import React, { useEffect, useState } from 'react';
import {
  withStyles,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  getBlacklistAllocations,
  createBlacklistAllocationsItem,
  deleteBlacklistAllocationsItem,
  setBlacklistAllocationsValues,
  updateBlacklistAllocations,
  resetBlacklistAllocations,
} from '~/store/dispatch/actions';
import classnames from 'classnames';
import PF2MDataTable from '~/components/PF2MDataTable';
import PF2MSearchSelectOutlined from '~/components/PF2MSearchSelectOutlined';
import styles from './styles';
import ReloadQueue from '../../ReloadQueue';

const BlackListAllocationsTab = ({
  classes,
}) => {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();
  const [dataLoaded, setDataLoaded] = useState(false);
  const blacklistAllocations = useSelector(state => state.dispatch.blacklistAllocations);
  const equipmentGroups = useSelector(state => state.nref.equipmentGroups);
  const equipments = useSelector(state => state.nref.equipments);
  const loadEquips = [1, 15];
  const trucks = [2];

  useEffect(() => {
    async function fetchData() {
      ReloadQueue.stopReload();
      dispatch(getBlacklistAllocations());
    }

    if (!dataLoaded) {
      fetchData();
      setDataLoaded(true);
    }
  }, [dataLoaded, dispatch]);

  const validateLookupField = key => (rowData) => {
    if (['', '0', 0].includes(rowData[key])) {
      return { isValid: false, helperText: translate('validation: RequiredField') };
    }
    return { isValid: true };
  };

  const validateBlacklistAllocationsDuplicates = key => (rowData) => {
    const findDuplicateLoads = blacklistAllocations.filter(
      b => b.id !== rowData.id && b.load_id === rowData[key],
    );
    if (findDuplicateLoads.length > 0) {
      return { isValid: false, helperText: 'Equipamento duplicado' };
    }

    return { isValid: true };
  };

  const validateTrucks = key => (rowData) => {
    if (rowData[key]?.length === 0) {
      return { isValid: false, helperText: translate('validation: RequiredField') };
    }
    return { isValid: true };
  };

  const setBlacklistTrucks = (e, row) => {
    const blacklistedTrucks = [...e.target.value.map(r => r.value)];
    dispatch(setBlacklistAllocationsValues({
      ...row,
      trucks: blacklistedTrucks,
    }));
  };

  const disableSaveAllButton = (blacklistAllocation) => {
    let anyEmptyBlalickAllocationTrucks = false;

    blacklistAllocation.forEach((ba) => {
      if (ba.trucks.length === 0) {
        anyEmptyBlalickAllocationTrucks = true;
      }
    });

    return anyEmptyBlalickAllocationTrucks;
  };

  const columns = [
    {
      editable: 'always',
      title: translate('common:EquipmentGroup'),
      field: 'id_group',
      required: true,
      customType: 'filterLookup',
      lookup: equipmentGroups.filter(eg => loadEquips.includes(eg.id_equipament)),
      validate: validateLookupField('id_group'),
    },
    {
      editable: 'always',
      field: 'load_id',
      title: translate('common:Equipment'),
      required: true,
      lookup: equipments.filter(eq => loadEquips.includes(eq.id_equip)),
      customType: 'filterLookup',
      lookupFilter: (lookup, rowData) => (
        String(lookup.id_group) === String(rowData.id_group)
      ),
      validate: validateBlacklistAllocationsDuplicates('load_id'),
    },
    {
      filtering: false,
      editable: 'never',
      title: translate('common:TruckEquipments'),
      field: 'trucks',
      required: true,
      render: row => (
        <PF2MSearchSelectOutlined
          value={row.trucks}
          placeholder={translate('common:Select')}
          multiple
          hideSelectedOptions={false}
          onChange={e => setBlacklistTrucks(e, row)}
          className={classnames(classes.field)}
        >
          {equipments.filter(eq => trucks
            .includes(eq.id_equip))
            .map(e => ({ value: e.id, label: e.name }))
          }
        </PF2MSearchSelectOutlined>
      ),
      validate: validateTrucks('trucks'),
    },
  ];

  return (
    <div className={classes.tabContainer}>
      <PF2MDataTable
        title="Blacklist"
        options={{
          showTitle: true,
          search: false,
          selection: true,
          filtering: true,
          pageSize: 20,
          pageSizeOptions: [20, 50, 100],
          hideDelete: false,
          disableSaveButton: disableSaveAllButton(blacklistAllocations),
          editableRowValidation: rowData => (rowData.id < 0 && rowData.update_status !== 'I'),
          maxBodyHeight: 'calc(100vh - 350px)',
          minBodyHeight: 'calc(100vh - 350px)',
        }}
        onAdd={newData => dispatch(createBlacklistAllocationsItem(newData))}
        onChange={(newData) => {
          newData.forEach((row) => {
            dispatch(setBlacklistAllocationsValues(row));
          });
        }}
        onDiscard={() => {
          dispatch(resetBlacklistAllocations());
        }}
        onDelete={(newData) => {
          newData.forEach((e) => {
            dispatch(deleteBlacklistAllocationsItem(e));
          });
        }}
        onApply={() => {
          const newData = blacklistAllocations.filter(e => e.update_status);
          dispatch(updateBlacklistAllocations(newData));
        }
        }
        columns={columns}
        data={blacklistAllocations?.length > 0 ? blacklistAllocations : []}
      />
    </div>
  );
};

export default withStyles(styles)(BlackListAllocationsTab);
